import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {AgmCoreModule} from '@agm/core';

@Component({
    selector: 'app-route-viewer-map',
    templateUrl: './route-viewer-map.component.html',
    styleUrls: ['./route-viewer-map.component.css']
})
export class RouteViewerMapComponent implements OnInit, AfterViewInit {

    mapLoaded: boolean;
    map: google.maps.Map;
    center: google.maps.LatLngLiteral;

    @Input() source: google.maps.LatLngLiteral;
    @Input() destination: google.maps.LatLngLiteral;
    @Input() title: string;
   // @ViewChild('mapid', {static: false}) mapElement: ElementRef;
    options: google.maps.MapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        zoomControl: false,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        gestureHandling: 'none',
        zoom: 12
    }
    ds: google.maps.DirectionsService;
    dr: google.maps.DirectionsRenderer;
    constructor() {
    }
    ngOnInit(): void {

    }

    min = 1;
    max = 100;
    randomNumber = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;;
    randomNumber2 = 2;


    setRoutePolyline() {
        let request = {
            origin: this.source,
            destination: this.destination,
            travelMode: google.maps.TravelMode.DRIVING
        };

        this.ds.route(request, (response, status) => {
            this.dr.setOptions({
                suppressPolylines: false,
                map: this.map
            });

            if (status == google.maps.DirectionsStatus.OK) {
                this.dr.setDirections(response);
            }
        })
    }

    ngAfterViewInit(): void {
        this.loadMap(this.randomNumber);
    }

    loadMap(mapId: number) {
        this.ds = new google.maps.DirectionsService();
        this.dr = new google.maps.DirectionsRenderer({
            map: null,
            suppressMarkers: true
        });
        navigator.geolocation.getCurrentPosition(position => {

            if (!this.source) {
                this.source = {
                    lat: -26.195246,
                    lng: 28.034088
                };
            }

            if (!this.destination) {
                this.destination = {
                    lat: -17.82772,
                    lng: 31.05337
                };

            }


            console.log("Map Id", mapId);
            // initialize the map container
            this.map = new google.maps.Map(document.getElementById(`map-${mapId}`), {
                ...this.options,
                center: this.source,

            });

            this.map.addListener('tilesloaded', () => {
                this.mapLoaded = true;
            });

            // adding a marker
            var markerStart = new google.maps.Marker({
                position: this.source,
                icon: {
                    url: './assets/imgs/destination_custom_pin.svg',
                    anchor: new google.maps.Point(35, 10),
                    scaledSize: new google.maps.Size(50, 50)
                },
                map: this.map
            });

            var destinationMarker = new google.maps.Marker({
                position: this.destination,
                icon: {
                    url: './assets/imgs/destination_custom_pin.svg',
                    anchor: new google.maps.Point(35, 10),
                    scaledSize: new google.maps.Size(50, 50)
                },
                map: this.map
            });

            this.setRoutePolyline();
        });
    }

    showBiggerMap(){
        //this.randomNumber2 = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
        this.loadMap(this.randomNumber2);
    }
}
